import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import { useShopActions } from '../../context/ShopActionsContext.jsx';
import SearchBar from './SearchBar.jsx';
import Logo from './Logo.jsx';

export default function Header() {
  const { isAuthenticated, user, role, logout } = useAuth();
  const { cartCount, wishlistCount, compareCount } = useShopActions();
  const accountPath = role === 'admin' ? '/admin' : role === 'marketer' ? '/marketer' : '/account';

  return (
    <header className="border-b bg-white">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-4 gap-y-3 px-4 py-3 sm:py-4">
        <Link to="/" aria-label="ITEC Mobiles & Computers — Home" className="shrink-0">
          <Logo className="h-11 sm:h-14" />
        </Link>

        {/* Search: full-width row on mobile, inline on lg+ */}
        <div className="order-3 w-full lg:order-2 lg:w-auto lg:flex-1 lg:max-w-2xl">
          <SearchBar />
        </div>

        <div className="order-2 ml-auto flex items-center gap-3 text-sm sm:gap-4 lg:order-3 lg:ml-0">
          {isAuthenticated ? (
            <>
              <Link to={accountPath} className="hidden sm:inline hover:text-brand-orange">
                Hi, {user?.name?.split(' ')[0] || 'You'}
              </Link>
              <Link to={accountPath} className="sm:hidden hover:text-brand-orange" aria-label="My account">
                Account
              </Link>
              <button onClick={logout} className="text-slate-500 hover:text-brand-orange">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="hover:text-brand-orange">Login</Link>
              <Link to="/register" className="hidden sm:inline hover:text-brand-orange">
                Register
              </Link>
            </>
          )}
          {isAuthenticated && (
            <Link to="/wishlist" className="hidden hover:text-brand-orange sm:inline">
              Wishlist ({wishlistCount})
            </Link>
          )}
          <Link to="/compare" className="hidden hover:text-brand-orange sm:inline">
            Compare ({compareCount})
          </Link>
          <Link
            to="/cart"
            className="relative inline-flex items-center rounded bg-brand-orange px-3 py-1.5 font-semibold text-brand-navy transition hover:bg-brand-yellow"
          >
            Cart ({cartCount})
          </Link>
        </div>
      </div>
    </header>
  );
}
